import "./styles.scss";

import IsOnline from "assets/img/svg/isOnline";
import { useTranslation } from "react-i18next";
import { PeriodActiveStatus } from "store/types";

/**
 * Render coloured status Chip for period status
 */
interface IPeriodStatusChip {
    periodStatus: number;
    style?: React.CSSProperties;
}

export const PeriodStatusChip = ({ periodStatus, style }: IPeriodStatusChip) => {
    const [t] = useTranslation();

    const chipStyles = {
        [PeriodActiveStatus.CLOSED]: {
            className: "closed",
            color: "#B55D5D",
            text: t("Management.ClosedPeriod"),
        },
        [PeriodActiveStatus.OPENED]: {
            className: "opened",
            color: "#848B4F",
            text: t("Management.OpenedPeriod"),
        },
        [PeriodActiveStatus.PENDING]: {
            className: "pending",
            color: "#9185CB",
            text: t("Management.FuturePeriod"),
        },
    };

    return (
        <div className={`period-status-chip-wrapper ${chipStyles[periodStatus].className}`} style={style}>
            <IsOnline fill={chipStyles[periodStatus].color} />
            <span>{chipStyles[periodStatus].text}</span>
        </div>
    );
};

export default PeriodStatusChip;
